import { create } from 'zustand';

// The data + handoff fields a workspace may register. Deliberately excludes the
// store's own methods (register/clear) so a caller can't clobber them (L27 fix,
// 2026-07-05). register() accepts only this narrowed shape.
interface PipelineRegisterable {
  generating: boolean;
  saving: boolean;
  hasWord: boolean;
  currentStage: string | null;
  completedStages: Set<string>;
  _generate: (() => void) | null;
  _forceSave: (() => void) | null;
  _navigateStage: ((stage: string) => void) | null;
  _getApprovePayload: (() => Record<string, unknown> | null) | null;
  _approve: ((payload: Record<string, unknown>) => void) | null;
}

interface PipelineState extends PipelineRegisterable {
  register: (actions: Partial<PipelineRegisterable>) => void;
  clear: () => void;
}

export const usePipelineStore = create<PipelineState>()((set) => ({
  generating: false,
  saving: false,
  hasWord: false,
  currentStage: null,
  completedStages: new Set(),

  _generate: null,
  _forceSave: null,
  _navigateStage: null,
  _getApprovePayload: null,
  _approve: null,

  register: (actions: Partial<PipelineRegisterable>) => set(actions),
  clear: () =>
    set({
      _generate: null,
      _forceSave: null,
      _navigateStage: null,
      _getApprovePayload: null,
      _approve: null,
      generating: false,
      saving: false,
      hasWord: false,
      currentStage: null,
      completedStages: new Set(),
    }),
}));
